// Revelstreet's own entity in identity_entity. Members of this entity should
// be treated as internal staff for select admin-only features (currently the
// Revel Recs admin) even when they aren't superusers.
export const REVELSTREET_STAFF_ENTITY_ID = 47

export type StaffCheckUser = {
  is_superuser: boolean
  active_entity_id: number | null
}

export const isRevelstreetStaff = (user: StaffCheckUser | null | undefined): boolean => {
  if (!user) return false
  if (user.is_superuser) return true
  return user.active_entity_id === REVELSTREET_STAFF_ENTITY_ID
}

// Convenience for callers holding a parsed domain User (with nested
// `active_entity`) — most commonly the auth store on the client.
type UserDomainShape = {
  is_superuser: boolean
  active_entity?: { id: number | null } | null
}

export const isRevelstreetStaffUser = (user: UserDomainShape | null | undefined): boolean => {
  if (!user) return false
  return isRevelstreetStaff({
    is_superuser: user.is_superuser,
    active_entity_id: user.active_entity?.id ?? null,
  })
}
